<script lang="ts">
import { defineComponent } from 'vue'
import MainPage from '@/components/MainPage.vue'
import { SofaEnvBanner } from '@ccwm/sofa-lib-vue-components'

export default defineComponent({
  components: {
    SofaEnvBanner,
    MainPage,
  },
  data() {
    return {
      env: import.meta.env.VITE_ENV,
      version: import.meta.env.VITE_VERSION,
    }
  },
})
</script>

<template>
  <div>
    <SofaEnvBanner
      :env="env"
      position="top-right"
    />
    <MainPage />
  </div>
</template>
